module.exports = __webpack_public_path__ + "img/mira_707m_list.478405cc.jpg";